'use client';
import React from 'react';
import Link from 'next/link';
import MultizoneLogo from '@/components/ui/MultizoneLogo';

export default function PublicHeader() {
  const messages = [
    'New Catalog Arrivals Are Now Live',
    'Bulk Inquiry Support Available',
    'Fast Response Within 24 Business Hours',
    'Get 5% Off on Orders Above ₹10,000',
  ];
  const marqueeMessages = [...messages, ...messages];

  return (
    <header className="fixed left-0 right-0 top-0 z-40 bg-zinc-950 shadow-sm">
      <div className="relative overflow-hidden border-b border-lime-200/20 bg-zinc-950 text-white">
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(217,249,157,0.14),rgba(9,9,11,0)_58%)]" />
        <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-lime-200/45 to-transparent" />
        <div className="relative flex h-11 items-center">
          <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-12 bg-gradient-to-r from-zinc-950 to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-12 bg-gradient-to-l from-zinc-950 to-transparent" />

          <div className="min-w-0 flex-1 overflow-hidden">
            <div className="animate-marquee flex w-max items-center gap-3 whitespace-nowrap">
              {marqueeMessages.map((message, index) => (
                <span
                  key={`announcement-${index}`}
                  aria-hidden={index >= messages.length}
                  className="inline-flex h-7 items-center rounded-full border border-white/10 bg-white/[0.06] px-3 text-[11px] font-semibold text-white/90 shadow-[inset_0_1px_0_rgba(255,255,255,0.12)]"
                >
                  {message}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link href="/" className="flex items-center gap-2">
          <MultizoneLogo widthClass="w-36" sizes="144px" priority />
        </Link>
      </div>
    </header>
  );
}
